import React, { useState, useContext } from 'react';
import { Clock, Sparkles, X, Lock, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import AppContext from '../../context/AppContext';

const ComingSoonAlert = ({ onClose, isPremiumFeature = true }) => {
  const navigate = useNavigate();
  const { userInfos } = useContext(AppContext);
  const isPlanGratuit = userInfos?.type_plan !== 'payant';
  
  const handleUpgradeClick = () => {
    onClose();
    navigate('/Plans');
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="relative bg-gradient-to-b from-white to-indigo-50 rounded-3xl shadow-2xl w-full max-w-lg mx-4 overflow-hidden">
        {/* Décorations d'arrière-plan */}
        <div className="absolute top-0 left-0 w-32 h-32 bg-indigo-100 rounded-full -translate-x-16 -translate-y-16" />
        <div className="absolute bottom-0 right-0 w-32 h-32 bg-purple-100 rounded-full translate-x-16 translate-y-16" />
        
        {/* Contenu principal */}
        <div className="relative">
          {/* Barre de poignée */}
          <div className="flex justify-center pt-4">
            <div className="w-12 h-1 bg-gray-200 rounded-full" />
          </div>

          {/* Bouton de fermeture */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={20} />
          </button>
          
          {/* En-tête */}
          <div className="flex justify-center mt-8">
            <div className={`${isPlanGratuit && isPremiumFeature ? 'bg-yellow-100' : 'bg-indigo-100'} p-3 rounded-2xl`}>
              {isPlanGratuit && isPremiumFeature ? (
                <Lock className="h-8 w-8 text-yellow-600" />
              ) : (
                <Clock className="h-8 w-8 text-indigo-600" />
              )}
            </div>
          </div>
          
          {/* Texte */}
          <div className="px-6 pt-6 pb-8 text-center">
            <div className="flex items-center justify-center gap-2 mb-2">
              <h2 className="text-xl font-bold text-gray-900">
                {isPlanGratuit && isPremiumFeature ? 'Fonctionnalité Premium' : 'Fonctionnalité à venir'}
              </h2>
              <Sparkles className="h-5 w-5 text-yellow-500" />
            </div>
            <p className="mt-2 text-gray-600">
              {isPlanGratuit && isPremiumFeature ? 
                'Cette fonctionnalité est réservée aux utilisateurs avec un plan payant. Passez à un plan premium pour y accéder.' : 
                'Cette fonctionnalité sera disponible très prochainement ! Nous travaillons activement pour vous l\'apporter.'}
            </p>
          </div>
          
          {/* Boutons */}
          <div className="px-6 pb-8">
            {isPlanGratuit && isPremiumFeature ? (
              <div className="flex flex-col gap-3">
                <button
                  onClick={handleUpgradeClick}
                  className="w-full py-3 bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600 text-white font-medium rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
                >
                  Voir les plans premium
                  <ArrowRight className="inline-block ml-2 h-4 w-4" />
                </button>
                <button
                  onClick={onClose}
                  className="w-full py-3 bg-gray-100 text-gray-700 hover:bg-gray-200 font-medium rounded-xl"
                >
                  Pas maintenant
                </button>
              </div>
            ) : (
              <button
                onClick={onClose}
                className="w-full py-3 bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white font-medium rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
              >
                J'ai compris
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};



export default ComingSoonAlert;